import Box from '@quintoandar/cozy-core/Box';
import Button from '@quintoandar/cozy-core/Button';
import Typography from '@quintoandar/cozy-core/Typography';
import Close from '@quintoandar/cozy-icons/Close';
import Download from '@quintoandar/cozy-icons/Download';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReactPlayer from 'react-player';
import Snackbar from '@quintoandar/cozy-core/Snackbar';
import messages from './messages';
import { useDeleteVideo } from './useDeleteVideo';
import { useDownloadVideo } from './useDownloadVideo';

export const VideoPreviewContainer = ({ videoLink, videoId, onVideoDeleted }) => {
  const intl = useIntl();
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState(null);
  const { isLoading: isDeletingVideo, mutate: deleteVideo } = useDeleteVideo();
  const { isLoading: isDownloadingVideo, mutate: downloadVideo } = useDownloadVideo();

  const onDeleteVideo = () => {
    deleteVideo(videoId, {
      onSuccess: onVideoDeleted,
      onError: () => setErrorSnackbarMessage(messages.errorDeletingVideo),
    });
  };

  const downloadFile = async () => {
    downloadVideo(videoId, {
      onSuccess: (data) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([data]));
        downloadLink.setAttribute('download', `${videoId}.mp4`);
        document.body.appendChild(downloadLink);


        downloadLink.click();
        document.body.removeChild(downloadLink);
      },
      onError: () => setErrorSnackbarMessage(messages.errorDownloadingVideo),
    });
  };

  return (
    <Box>
      <Typography level="heading">
        <FormattedMessage {...messages.videoUpload} />
      </Typography>
      <Box mt={3}>
        <FormattedMessage {...messages.uploadPreview} />
        <Box mt={2} display="flex" alignItems="center" justifyContent="center" style={{ backgroundColor: '#f5f5f5' }}>
          <ReactPlayer url={`https://vimeo.com/${videoLink}`} controls width="1000px" height="450px" />
        </Box>
      </Box>
      <Box mt={6} display="flex" alignItems="center" justifyContent="flex-end">
        <Button
          variant="quietDestructive"
          icon={Close}
          onClick={onDeleteVideo}
          disabled={isDeletingVideo}
          isLoading={isDeletingVideo}
        >
          <FormattedMessage {...messages.discardVideo} />
        </Button>
        <Box ml={2}>
          <Button
            variant="quiet"
            icon={Download}
            onClick={downloadFile}
            isLoading={isDownloadingVideo}
            disabled={isDownloadingVideo}
          >
            <FormattedMessage {...messages.downloadVideo} />
          </Button>
        </Box>
      </Box>
      <Snackbar
        color="error"
        open={Boolean(errorSnackbarMessage)}
        message={errorSnackbarMessage ? intl.formatMessage(errorSnackbarMessage) : ''}
        onClose={() => setErrorSnackbarMessage(null)}
      />
    </Box>
  );
};

VideoPreviewContainer.propTypes = {
  videoLink: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  onVideoDeleted: PropTypes.func.isRequired,
};
